import { createSlice } from '@reduxjs/toolkit';
import { fetchWaitlist, createWaitlistEntry, deleteWaitlistEntry } from '../thunks/waitlistThunks';

const initialState = {
  waitlist: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
    limit: 10
  }
};

const waitlistSlice = createSlice({
  name: 'waitlist',
  initialState,
  reducers: {
    clearWaitlistError: (state) => {
      state.error = null;
    },
    setWaitlistPage: (state, action) => {
      state.pagination.page = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch all waitlist entries
      .addCase(fetchWaitlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWaitlist.fulfilled, (state, action) => {
        state.loading = false;
        state.waitlist = action.payload.waitlist;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchWaitlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch waitlist entries';
      })
      
      // Create waitlist entry
      .addCase(createWaitlistEntry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWaitlistEntry.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update the list if needed
        // state.waitlist = [action.payload, ...state.waitlist];
      })
      .addCase(createWaitlistEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to create waitlist entry';
      })
      
      // Delete waitlist entry
      .addCase(deleteWaitlistEntry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteWaitlistEntry.fulfilled, (state, action) => {
        state.loading = false;
        state.waitlist = state.waitlist.filter(entry => entry._id !== action.meta.arg);
      })
      .addCase(deleteWaitlistEntry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete waitlist entry';
      });
  }
});

export const { clearWaitlistError, setWaitlistPage } = waitlistSlice.actions;
export default waitlistSlice.reducer;
